import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as Styled from "./sidemenuStyled";

import logoImage from "../../images/coffeee-logo-icon.svg";
import logoText from "../../images/coffeee-logo-text.svg";
import dashboard from "../../images/dashboard.svg";
// import assessment from '../../images/assessment.svg';
import course from "../../images/course.svg";
import videos from "../../images/videos.svg";
import communities from "../../images/communities.svg";
import recruiters from "../../images/recruiters.svg";
import shortlists from "../../images/shortlist.svg";
import masterSettings from "../../images/master-settings.svg";
import clm_icon from "../../images/clm_icon.svg";
import linkedin1 from "../../images/linkedin1.svg";
import linkedin2 from "../../images/linkedin2.svg";
import debrief from "../../containers/DebriefTable";
import assessmentActive from "../../images/assessment-active.svg";

import logout from "../../images/logout.svg";
let savedSidemenuScrollTop = 0;
class Sidemenu extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.state = {
      expand: null,
      adminAccess: localStorage.getItem("adminAccess"),
      menu: [
        {
          name: "Coffeee Plus",
          iconInactive: dashboard,
          iconActive: assessmentActive,
          active: false,
          url: "/coffeee-plus",
          access: []
        },
        {
          name: "Contest Plus",
          iconInactive: assessmentActive,
          iconActive: assessmentActive,
          url: "/contest-plus",
          active: false,
          access: []
        },
        {
          name: "Email Management",
          iconInactive: clm_icon,
          iconActive: "",
          active: false,
          url: "/coffeee-clm",
          access: []
          
        },
        {
          name: "Assessment",
          iconInactive: assessmentActive,
          iconActive: assessmentActive,
          active: false,
          subMenu: [
            {
              name: "Questions",
              url: "assessment-question",
              active: false,
            },
            {
              name: "Test",
              url: "assessment-test",
              active: false,
            },
            {
              name: "Test Groups",
              url: "assessment-group",
              active: false,
            },
            {
              name: "Bash Questions",
              url: "bash-questions",
              active: false,
            },
          ],
          access: [0]
          
        },
        {
          name: "Trainings",
          iconInactive: videos,
          iconActive: "",
          active: false,
          url: "/training",
          access: []
          
        },
        {
          name: "Recruiters",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/candidateRequest",
          access: []
          
        },
        {
          name: "Articles",
          iconInactive: videos,
          iconActive: "",
          url: "/articles",
          active: false,
          access: []
          
        },
        {
          name: "Update Users Details",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/update-user-details",
          access: []
          
        },
        {
          name: "Candidate Laterals",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/candidate-laterals",
          access: []
          
        },
        {
          name: "Practice",
          iconInactive: assessmentActive,
          iconActive: assessmentActive,
          active: false,
          subMenu: [
            {
              name: "Test",
              url: "practice-assessment-test",
              active: false,
            },
          ],
          access: []
          
        },
        {
          name: "Linkedin",
          iconInactive: linkedin1,
          iconActive: linkedin2,
          url: "/easyapply/get-all",
          active: false,
          access: []
          
        },
        {
          name: "Machine Interview",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/machine-interview",
          access: []
          
        },
        {
          name: "Coffeee People",
          iconInactive: assessmentActive,
          iconActive: assessmentActive,
          url: "/coffeee-plus-Search",
          active: false,
          access: [0]
        },
        {
          name: "Demand Form",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/demand-form",
          access: [0, 1, 2]
        },
        {
          name: "Submission Form",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/submission-form",
          access: [3]
        },

        {
          name: "User Management",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/recruiter-management",
          access: [0]
        },
        {
          name: "Demand Table",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/demand-table",
          access: [0, 1, 2, 3]
        },
        {
          name: "Demand Dashboard",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/demand-dashboard",
          access: [0, 1, 2]
        },

        {
          name: "Reference Table",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/debrief-table",
          access: [0, 1, 2, 3]
        },

        {
          name: "Candidate Tracking",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/candidate-table",
          access: [3]
        },
        // {
        //   name: "Profiles Table",
        //   iconInactive: shortlists,
        //   iconActive: shortlists,
        //   active: true,
        //   url: "/profile-table",
        //   access: [2,3]
        // },
        {
          name: "Candidate Tracking",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/reviewer-table",
          access: [0, 1]
        },
        {
          name: "Profile Sent Table",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/profile-sent-table",
          access: [0, 2]
        },
        {
          name: "Interview Table",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/interview-table",
          access: [0, 1, 2, 3]
        },
        {
          name: "Performance Report",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/performance-report",
          access: [0, 1, 2, 3]
        },
        {
          name: "Review Dashboard",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/review-dashboard",
          access: [0, 1, 2]
        },
        {
          name: "Client Dashboard",
          iconInactive: shortlists,
          iconActive: shortlists,
          active: false,
          url: "/client-dashboard",
          access: [0, 1, 2, 3]
        },
        // {
        //   name: "Company Table",
        //   iconInactive: shortlists,
        //   iconActive: shortlists,
        //   active: true,
        //   url: "/company-table",
        //   access: [3]
        // },
      ],
    };
  }

  UNSAFE_componentWillMount() {
    const menu = this.state.menu;
    let expand = this.state.expand;
    const pathname =
      (window && window.location && window.location.pathname) || "";

    if (pathname !== "") {
      // Get the full path instead of just the first segment
      const fullPath = pathname.substring(1); // Remove leading slash

      for (let x = 0; x < menu.length; x += 1) {
        const m = menu[x];
        // Remove leading slash from menu URLs for comparison
        const menuUrl = m.url ? m.url.replace(/^\//, '') : '';

        if (typeof m.url !== "undefined" && menuUrl === fullPath) {
          m.active = true;
        } else if (typeof m.subMenu !== "undefined" && m.subMenu.length > 0) {
          for (let y = 0; y < m.subMenu.length; y += 1) {
            const s = m.subMenu[y];
            if (typeof s.url !== "undefined" && s.url === fullPath) {
              s.active = true;
              m.active = true;
              expand = x;
            }
          }
        }
      }
    }

    this.setState({ menu, expand });
  }
  componentDidMount() {
    if (this.menuRef.current) {
      this.menuRef.current.scrollTop = savedSidemenuScrollTop;
    }
  }

  handleMenuScroll = (e) => {
    savedSidemenuScrollTop = e.target.scrollTop;
  };

  expandMenu = (value) =>
    this.setState({ expand: value !== this.state.expand ? value : null });

  render() {
    const { menu, expand, adminAccess } = this.state;
    const { collapsed } = this.props;
    return (
      <Styled.MainDiv collapsed={collapsed}>
        <Styled.LogoDiv>
          <img src={logoImage} alt="logo-icon" />
          <img src={logoText} alt="logo-text" />
        </Styled.LogoDiv>

        <Styled.MenuDiv ref={this.menuRef} onScroll={this.handleMenuScroll}>
          {menu.map((m, mIndex) => {
            // Only render the menu item if the user's access level matches the allowed access
            if (!m.access.includes(Number(adminAccess))) {
              return null;  // Skip rendering this menu item
            }

            const menuIcon = m.active ? m.iconActive : m.iconInactive;
            const haveSub =
              typeof m.subMenu !== "undefined" && m.subMenu.length > 0;
            const isExpand = expand === mIndex;
            return (
              <Styled.ColumnOneDiv key={`column_${mIndex}`}>
                {m.url ? (
                  <Styled.LevelOneLink
                    color={m.active ? "#ffffff" : "#706D9D"}
                    to={m.url}
                  >
                    <img src={menuIcon} alt={m.name} />
                    <div>{m.name}</div>
                  </Styled.LevelOneLink>
                ) : (
                  <Styled.LevelOneDiv
                    onClick={() => this.expandMenu(mIndex)}
                    haveSub={haveSub}
                    isExpand={isExpand}
                    color={m.active ? "#ffffff" : "#706D9D"}
                  >
                    <img src={menuIcon} alt={m.name} />
                    <div>{m.name}</div>
                  </Styled.LevelOneDiv>
                )}

                {haveSub && (
                  <Styled.ColumnTwoDiv
                    sub={m.subMenu.length}
                    isExpand={isExpand}
                  >
                    {m.subMenu.map((sub) => (
                      <Styled.LevelTwoLink
                        color={sub.active ? "#ffffff" : "#706D9D"}
                        to={{ pathname: `/${sub.url}` }}
                        key={sub.name}
                      >
                        {sub.name}
                      </Styled.LevelTwoLink>
                    ))}
                  </Styled.ColumnTwoDiv>
                )}
              </Styled.ColumnOneDiv>
            );
          })}
          <Styled.LogoutLink
            to="/login"
            onClick={() => {
              localStorage.removeItem("jwtToken");
              localStorage.removeItem("user_name");
              localStorage.removeItem("adminAccess");
            }}
          >
            <img src={logout} alt="logout" />
            Logout
          </Styled.LogoutLink>
        </Styled.MenuDiv>
      </Styled.MainDiv>
    );
  }
}

export default Sidemenu;